<template>
  <div class="main-pane virtual-open-day">
    <div class="scroll--icon"><div class="icon"><DragIcon/></div><div class="text">Scroll and tap to enjoy</div></div>
    <TrinityHeader v-if="isClient('trinity')"/>
    <div class="spacer--disabled"/>
    <div class="section" v-for="(section,index) in pageData" :key="index">
      <Journey :steps="section.items" v-if="section.type == 'journey'"/>
      <Map :mapItems="section.items" :title="section.title" v-if="section.type == 'map'"/>
      <InformationBars v-if="section.type == 'information'" :header="sectionHeader(section)" :informationItems="sectionItems(section)" :key="section.id"/>
      <Tiles v-if="section.type == 'tile'" :items="section.items"/>
      <Carousel v-if="section.type == 'carousel'" :items="section.items"/>
      <Counters v-if="section.type == 'configuration' && section.items && section.items.configuration && section.items.configuration.type == 'counter'" :configuration="section.items.configuration"/>
      <VideoButtonGrid v-if="section.type == 'configuration' && section.items && section.items.configuration && section.items.configuration.type == 'video-button-grid'" :configuration="section.items.configuration"/>
    </div>
    <YouTubeVideoModal/>
    <!-- <PembrokeFooter v-if="isClient('pembroke')"/>
    <TrinityFooter v-if="isClient('trinity')"/> -->
    <!-- <div class="spacer"/> -->
  </div>
</template>

<script>
import axios from "axios"
//We need to import at least one component to load gsap, scrollmagic properly
import Journey from "@/components/Journey.vue"
import YouTubeVideoModal from "@/components/YouTubeVideoModal"
import DragIcon from "@/assets/svg/drag.svg"

export default {
  name: "VirtualOpenDay",
  components: {
    DragIcon,
    Journey,
    Map: () => import(/* webpackPrefetch: true */ '@/components/Map.vue'),
    InformationBars: () => import(/* webpackPrefetch: true */ '@/components/InformationBars.vue'),
    Tiles: () => import(/* webpackPrefetch: true */ '@/components/Tiles.vue'),
    Carousel: () => import(/* webpackPrefetch: true */ '@/components/Carousel.vue'),
    Counters: () => import(/* webpackPrefetch: true */ '@/components/Counters.vue'),
    VideoButtonGrid: () => import(/* webpackPrefetch: true */ '@/components/VideoButtonGrid.vue'),
    // PembrokeFooter: () => import(/* webpackPrefetch: true */ '@/footers/PembrokeFooter.vue'),
    // TrinityFooter: () => import(/* webpackPrefetch: true */ '@/footers/TrinityFooter.vue'),
    TrinityHeader: () => import(/* webpackPrefetch: true */ '@/headers/TrinityHeader.vue'),
    YouTubeVideoModal
  },
  data() {
    return {
      pageData: [],
      errors: []
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {

    },
    init() {
      this.loadingIndicator();
      let c = this;

      //@todo: Should move this to root Vue app - https://laracasts.com/discuss/channels/laravel/pass-a-variable-to-vuejs
      let n = document.querySelector('#nid').getAttribute('data-id');

      axios
        .get(
          `/page-app/data/${n}`
        )
        .then(function(response) {
          c.pageData = response.data;
          return response.data;
        })
        .catch(e => {
          this.errors.push(e);
        });

    },
    loadingIndicator() {

    },
    sectionHeader(section) {

      let header = {};
      Object.keys(section.items).forEach(key => {
        if (section.items[key].type == 'header') {
          header = section.items[key]
        }
      })
      return header;
    },
    sectionItems(section) {
      let items = {};
      Object.keys(section.items).forEach(key => {
        if (section.items[key].type != 'header') {
          items[key] =section.items[key];
        }
      })
      return items;
    },
    isClient(clientName) {
      return process.env.VUE_APP_CLIENT_ID == clientName;
    }
  },
  computed: {
    loadingActive() {
      return this.dayData.data && Object.keys(this.dayData.data).length > 0 ? "inactive" : "active";
    },
    
  },
  ready: function () {
    window.addEventListener('resize', this.chartSize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.chartSize)
  }
};
</script>

<style>
.multiselect__tag {
    background-color: #30b5e4;
    color: #0b1f3e;
}

</style>

<style scoped lang="scss">

.spacer {
  width: 100%;
  height: 600px;
  background-color: #eeeeee;
}


</style>